/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MagiJobResponseBase } from '../models/MagiJobResponseBase';
import type { MagiTranscribeRetryCallbackRequest } from '../models/MagiTranscribeRetryCallbackRequest';
import type { MagiTranscribeRetryJobResponse } from '../models/MagiTranscribeRetryJobResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ForMagiTranscribeRetryService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Transcribe Retry
   * @param id
   * @param requestBody
   * @returns MagiJobResponseBase Successful Response
   * @throws ApiError
   */
  public transcribeRetryV1WorkspacesSlugRecordsIdTranscribeRetryPost(
    id: number,
    requestBody: MagiTranscribeRetryCallbackRequest
  ): CancelablePromise<MagiJobResponseBase> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/records/{id}/transcribe/retry',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Transcribe Retry Poll
   * @param transcribeId
   * @returns MagiTranscribeRetryJobResponse Successful Response
   * @throws ApiError
   */
  public transcribeRetryPollV1WorkspacesSlugRecordsIdTranscribeRetryTranscribeIdGet(
    transcribeId: string
  ): CancelablePromise<MagiTranscribeRetryJobResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/records/{id}/transcribe/retry/{transcribe_id}',
      path: {
        transcribe_id: transcribeId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
